import { useState, useEffect } from 'react'
import { Navbar, Container, Nav } from 'react-bootstrap'
import navIcon1 from '../assets/img/nav-icon1.svg'
import gith from '../assets/img/git.png'
import navIcon3 from '../assets/img/nav-icon3.svg'
import brandLogo from '../assets/img/lion.jpg'


export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scroll, setScroll] = useState(false);

    useEffect (() => {
        const onScroll = () => {
            if(window.scrollY > 0) {
                setScroll(true)
            }else {
                setScroll(false)
            }
        }

        window.addEventListener('scroll', onScroll);

        return() => window.removeEventListener('scroll', onScroll)
    }, [])

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }

    return ( 
        <Navbar  className={scroll ? "scrolled" : ""} expand="lg">
      <Container>
        <Navbar.Brand className='text-white' href="#home">
          <img src={brandLogo} alt="logo" className='nav__logo' />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className='navbar-toggler-icon'></span>
            </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')} >Home</Nav.Link>
            <Nav.Link href="#experience" className={activeLink === 'experience' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('experience')} >Experience</Nav.Link>
            <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')} >Skills</Nav.Link>
            <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')} >Projects</Nav.Link>
          </Nav>
          <span className='navbar-text'>
            <div className='social-icon'>
                    <a href='https://www.linkedin.com/in/mariano-emmanuel-veron-santos-oliveira-bb791b208/'><img src={navIcon1} alt='' /></a>
                    <a href='https://github.com/Maranelo97'><img src={gith} alt='' /></a>
                    <a href='https://www.instagram.com/marianoverondamvp97/'><img src={navIcon3} alt='' /></a>
            </div>
            <button className='vvd'><a href='#contact'>Lets Conect</a></button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
     )
}